import React from 'react';
import '../../../css/Grupo1/G1Landing.css';
import KsAsigEjTabla from '../../../Component/Grupo1/KsAsigEjTabla';

function KsAsEjercicios() {

return(

    <div className="g1_wrapper">
      <div className="g1_body_alt">
      <KsAsigEjTabla/>
      </div>
    </div>
                    
  );
}

export default KsAsEjercicios;